
define('text!presentation/common/infoBox/views/infoBoxShell.html',[],function () { return '<div class="info-box">\n    <div data-part="infoBoxContent"/>\n</div>';});

